import React, { Component } from 'react';
import { Icon, Select } from 'antd';
import { flatten, uniq, uniqWith, pick, isEqual } from 'lodash';

import { observer, inject } from 'mobx-react';

import { isFunction } from 'lodash';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class MaintenanceTypeFilter extends Component {
  keyStorage = `carFilter_maintenance`;

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      maintenanceType: [],
      selectedMaintenanceType: null
    };
  }

  componentDidMount() {
    if (this.props.carsStore.cars) {
      this.init(this.props.carsStore.cars);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  init(cars) {
    this.setState({ cars }, () => {
      this.initMaintenanceType();
    });
  }

  initMaintenanceType = () => {
    const { filterStore } = this.props;
    const maintenanceType = uniqWith(
      flatten(this.props.carsStore.cars.filter(car => car.maintenances && car.maintenances.length > 0).map(car => car.maintenances)).map(maintenance =>
        pick(maintenance, ['type', 'custom'])
      ),
      isEqual
    );
    this.setState({ maintenanceType });

    if (filterStore.appliedFiltersParameters && filterStore.appliedFiltersParameters.hasOwnProperty(this.keyStorage)) {
      const { selectedMaintenanceType } = filterStore.appliedFiltersParameters[this.keyStorage];
      this.setState({ selectedMaintenanceType });
    }
  };

  selectMaintenance = maintenance => {
    const { filterStore } = this.props;
    try {
      maintenance = JSON.parse(maintenance);
    } catch (e) {
      maintenance = null;
    }
    this.setState({ selectedMaintenanceType: maintenance });
    if (maintenance) {
      filterStore.add('carFilter_maintenance', car => {
        return !!car.maintenances ? car.maintenances.findIndex(m => m.type === maintenance.type && m.custom === maintenance.custom) > -1 : false;
      }, undefined, { selectedMaintenanceType: maintenance });
    } else {
      filterStore.remove('carFilter_maintenance');
    }
  };

  removeMaintenance = () => {
    const { filterStore } = this.props;
    this.setState({ selectedMaintenanceType: null });
    filterStore.remove('carFilter_maintenance');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        selectedMaintenanceType: null
      });
    }
  };

  render() {
    const { selectedMaintenanceType } = this.state;
    const { translationsStore, carsStore } = this.props;
    return (
      <div id="maintenanceTypeFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.maintenanceType')}
          {selectedMaintenanceType && (
            <span>
              {translationsStore.translate(`carList.maintenanceType.${selectedMaintenanceType.type}.${selectedMaintenanceType.custom ? 'custom' : 'default'}`)}
              <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeMaintenance} />
            </span>
          )}
        </div>
        <Select
          value={selectedMaintenanceType ? JSON.stringify(selectedMaintenanceType) : selectedMaintenanceType}
          getPopupContainer={() => document.getElementById('maintenanceTypeFilter')}
          onChange={this.selectMaintenance}
        >
          {carsStore.maintenanceType.map((maintenance, index) => (
            <Select.Option value={JSON.stringify(maintenance)} key={index}>
              {translationsStore.translate(`carList.maintenanceType.${maintenance.type}.${maintenance.custom ? 'custom' : 'default'}`)}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}
